import { Icon, TableBody, TableHead, TableRow } from "@mui/material";
import TableComponent, {
  StyledBodyCell,
  StyledHeaderCell,
  StyledTableRow,
} from "../../components/Table";
import theme from "../../styles/theme";
import { ClickableIcon } from "../../components/Icon";
import { useNavigate } from "react-router-dom";

interface Props {
  competencyList: any;
  loading?: boolean;
  variant?: "code" | "competency";
}
export const CompetencyTable = (props: Props) => {
  const { competencyList, loading, variant = "code" } = props;
  const navigate = useNavigate();
  const getCurriculumVersion = (row: any) => {
    const v = row?.version_number ?? row?.curriculum_version ?? row?.display_version;
    const n = typeof v === "number" ? v : parseFloat(String(v));
    return Number.isFinite(n) ? n : null;
  };

  const displayCompetencyList =
    variant === "competency"
      ? (competencyList ?? [])
        .slice()
        .sort((a: any, b: any) => {
          const av = getCurriculumVersion(a);
          const bv = getCurriculumVersion(b);

          if (av !== null && bv !== null && av !== bv) return bv - av;
          if (av !== null && bv === null) return -1;
          if (av === null && bv !== null) return 1;

          return String(a?.competency_code ?? "").localeCompare(
            String(b?.competency_code ?? "")
          );
        })
      : competencyList;

  const columns =
    variant === "competency"
      ? [
        { id: "competency_code", label: "Competency code" },
        { id: "credits", label: "Credits" },
        { id: "display_version", label: "Version" },
        { id: "identity_code", label: "Identity Code", minWidth: 50 },
        { id: "title", label: "Title", minWidth: 200 },
        { id: "pillar_title", label: "Pillar", minWidth: 150 },
        { id: "subdomain_title", label: "Subdomain", minWidth: 150 },
        { id: "view", label: "", minWidth: 10 },
      ]
      : [
        // Original code-based order (do not change)
        { id: "identity_code", label: "Identity Code" },
        { id: "credits", label: "Credits" },
        { id: "display_version", label: "Version" },
        { id: "competency_code", label: "Competency code", minWidth: 50 },
        { id: "title", label: "Title", minWidth: 200 },
        { id: "pillar_title", label: "Pillar", minWidth: 150 },
        { id: "subdomain_title", label: "Subdomain", minWidth: 150 },
        { id: "view", label: "", minWidth: 10 },
      ];

  const searchProgram = localStorage.getItem("searchProgram")
  if (competencyList?.length === 0 && !loading) {
    return (
      <div
        style={{
          display: "flex",
          padding: 16,
          background: "#eef5fd",
          alignItems: "center",
        }}
      >
        <Icon fontSize="small" style={{ color: "#2a34cc", marginRight: 5 }}>
          info_icon
        </Icon>
        No competency found!
      </div>
    );
  }
  return (
    <TableComponent aria-label="sticky table">
      <TableHead>
        <TableRow>
          {columns.map((column) => (
            <StyledHeaderCell
              key={column.id}
              //   align={column.align}
              backgroundColor={theme.color.lightBlueGray50}
              color={theme.color.lightBlueGray800}
              style={{ minWidth: column.minWidth }}
            >
              {column.label}
            </StyledHeaderCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {displayCompetencyList?.length !== 0 ? (
          displayCompetencyList?.map((row: any, index: number) => {
            return (
              <StyledTableRow
                onDoubleClick={() => {
                  navigate(
                    `view/competency/detail/${row.competency_code}/${row.university_code}/${row.curriculum_version}`
                  )
                  localStorage.setItem("searchProgram", searchProgram || "");
                  localStorage.setItem("searchUniversity", row?.university_code);
                }
                }
                // selected={searchId === row.id}
                hover
                role="checkbox"
                tabIndex={-1}
                // ref={searchId === row.id ? ref : null}
                key={index}
              >
                {columns.map((column) => {
                  if (column.id === "view") {
                    return (
                      <StyledBodyCell
                        className="reduce_opct_onhover"
                        style={{ verticalAlign: "middle", color: "#3939fa" }}
                        key={column.id}
                        align={"right"}
                        onClick={() => {
                          navigate(
                            `view/competency/detail/${row["competency_code"]}/${row["university_code"]}/${row["curriculum_version"]}`
                          );
                        }}
                      >
                        <Icon fontSize="small" style={{ paddingRight: 10 }}>
                          visibility_icon
                        </Icon>
                      </StyledBodyCell>
                    );
                  }
                  const value = row[column.id];
                  return (
                    <StyledBodyCell key={column.id}>{value}</StyledBodyCell>
                  );
                })}
              </StyledTableRow>
            );
          })
        ) : (
          <StyledTableRow
            hover
            role="checkbox"
            tabIndex={-1}
            style={{ background: "#eef5fd" }}
            // onClick={() => {
            //   onSelect(row);
            // }}
            key={0}
          >
            <StyledBodyCell key={1} align={"left"} colSpan={8}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Icon
                  fontSize="small"
                  style={{ color: "#2a34cc", marginRight: 5 }}
                >
                  info_icon
                </Icon>
                No competency found!
              </div>
            </StyledBodyCell>
          </StyledTableRow>
        )}
      </TableBody>
    </TableComponent>
  );
};
